import { useCanViewEmails } from '../../../helpers/useCanViewEmails';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Tooltip } from '@material-ui/core';

import { RolesLowerCase } from '../../../enums/ROLES';
import Avatar from '../Avatar';
import { User } from '../OrganizationCard';
import RolePlate from '../RolePlate';
import styles from './Users.module.scss';
import { SortFields, SortType } from '../../../enums/SORT';
import { USER_NEW } from '../../../enums';

type TOrganizationUsersHeader = {
  sortByType: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  sortField: SortFields;
  sortType: SortType;
};

const USER_FILTER_CELLS = [
  { label: 'Name', value: SortFields.NAME },
  { label: 'Email', value: SortFields.EMAIL },
  { label: 'Role', value: SortFields.ROLE },
  { label: 'Organisation', value: SortFields.ORGANIZATION_NAME },
];

export const OrganizationUsersHeaderSelector: React.FC<TOrganizationUsersHeader> = ({ sortByType, sortField, sortType }) => {
  const canViewEmails = useCanViewEmails();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {USER_FILTER_CELLS.map((cell) => cell.value === SortFields.EMAIL && !canViewEmails ? null : (
          <div className={styles.headerSection} key={cell.label}>
            <button type="button" name={cell.value} onClick={sortByType} className={styles.btn}>
              {cell.label}
              {sortType === SortType.DESC && sortField === cell.value ? (
                <KeyboardArrowUpIcon name={cell.value} />
              ) : (
                <KeyboardArrowDownIcon name={cell.value} />
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export const OrganizationUserSelector = ({ user }: { user: USER_NEW; fetchData: () => Promise<unknown>; selectMode?: boolean }) => {
  const canViewEmails = useCanViewEmails();
  return (
    <div className={styles.container}>
      <div className={styles.user}>
        <div className={styles.leftSide}>
          <Avatar avatar={user.user.avatar_url} name={user?.user.username || user?.role.title.replace('Organization', 'Organisation')} />
          <div className={styles.info}>
            <Tooltip title={user?.user.username ?? user?.role.title.replace('Organization', 'Organisation')}>
              <div className={styles.name}>{user?.user.username ?? user?.role.title.replace('Organization', 'Organisation')}</div>
            </Tooltip>
            {canViewEmails && (<Tooltip title={user.user.email}>
              <div className={styles.email}>{user.user.email}</div>
            </Tooltip>)}
          </div>
        </div>
        {/* <div className={styles.org}>{user.user.organization_name}</div> */}
        <div className={styles.role}>
          <Tooltip title={!user.user.invitation_token ? 'Active' : 'Not activated'}>
            <div className={!user.user.invitation_token ? styles.active : styles.notActive}>
              <RolePlate userRole={user.role.title === RolesLowerCase.ORGANIZATION_ADMIN ? 'OA' : user.role.title} />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
